var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "19px",
    viewBox: "0 0 45 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main",
    transform: "translate(-1175.000000, -16.000000)",
    fill: "#00458A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(1175.750000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.24696424 L15.3998466,4.24696424 C17.1089216,6.20887048 19.2515748,7.70682605 21.9504598,8.6698263 L2.65900989,8.6698263 L0,4.24696424 Z M21.0106199,1.77635684e-15 C22.6858769,2.75627051 25.0637424,4.24696424 30.0975893,4.24696424 L37.454789,4.24696424 L40.1158179,8.6698263 L30.0975893,8.6698263 C21.7101999,8.6698263 17.1033694,5.45606007 14.3222106,1.77635684e-15 L21.0106199,1.77635684e-15 Z M43.75,14.4688064 L28.3491439,14.4688064 C26.6395641,12.5073036 24.4974157,11.0093481 21.7995402,10.0479616 L41.0925044,10.0479616 L43.75,14.4688064 Z M22.7378659,18.7165775 C21.0636184,15.9615173 18.6902956,14.4688064 13.6519059,14.4688064 L6.29420146,14.4688064 L3.63418208,10.0479616 L13.6519059,10.0479616 C22.0398001,10.0479616 26.6456211,13.2605175 29.4267799,18.7165775 L22.7378659,18.7165775 Z",
    id: "Fill-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b189c76d6921ac435e5008c89595ea4.svg";
export { ForwardRef as ReactComponent };